<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="uniToolTipTranslation('Q1114', 'en-US')"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="height:100%; margin-bottom: 0px !important"
      >
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          <!--{{ uniTranslation("Q1114") }}-->
          {{ uniTranslation(cardLabel) }}
        </div>

        <div>
          <div class="row no-gutters" style="margin-bottom: 9px">
            <div class="col-3">
              <div class="label-unidato">
                &nbsp;
              </div>
            </div>
            <div class="col-9">
              <div class="el-select fluidSelect">
                &nbsp;
              </div>
            </div>
          </div>
        </div>

        <UnidataEditor
          :parent-path="path"
          :name="'.flow'"
          :auto-decimals="4"
          :um-show="'kg/h;kg/s;lb/s;lb/h'"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.saturationPressure'"
          :correlated-fields="['.saturationTemperature']"
          :auto-decimals="4"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.saturationTemperature'"
          :correlated-fields="['.saturationPressure']"
          :auto-decimals="4"
        ></UnidataEditor>

        <!--
          Richiesto di togliere in data 08/04/2020
        <UnidataEditor
          :parent-path="path"
          :name="'.outletTemperature'"
          :auto-decimals="4"
        ></UnidataEditor>
        -->

        <UnidataEditor
          :parent-path="path"
          :name="'.pressureDrop'"
          :um-not-show="'bar G'"
          :auto-decimals="4"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.foulingFactor'"
          :auto-decimals="8"
          :min="0"
        ></UnidataEditor>

        <span v-if="bMostraOutput">
          <p>&nbsp;</p>
          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.fluidVelocityConnections'"
              :auto-decimals="4"
            ></UnidataEditor>
          </div>
          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.fluidVelocityChannel'"
              :auto-decimals="4"
            ></UnidataEditor>
          </div>
        </span>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditor from "../unidata/UnidataEditor";
import { mapGetters } from "vuex";
import colorsService from "../../services/backend/colorsService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    UnidataEditor
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      showFluidFlow: false,
      coloreSfondo: "",
      coloreTesto: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreSfondoTab: "",
      coloreTestoTab: "",
      coloreBordo: "",
      cardLabel: ""
    };
  },
  computed: {
    ...mapGetters(["projects"]),
    bMostraOutput: function() {
      if (this.$store.getters.status_Verifica) {
        return this.$store.getters.status_PostCalcolo;
      } else if (this.$store.getters.status_Selezione) {
        return this.$store.getters.status_PostCalcolo;
      } else {
        return false;
      }
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    //colorsService.getColoriCard().then(function(data) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
    that.coloreBarraTitolo = colorList[1];
    that.coloreTesto = colorList[2];
    that.coloreTitolo = colorList[3];
    that.coloreSfondoTab = colorList[4];
    that.coloreTestoTab = colorList[5];
    that.coloreBordo = colorList[6];
    let specificHeaderBackColor = jsonHelper.getProperty(
      that.projects,
      that.path + ".cardHeaderBackColor"
    );
    if (specificHeaderBackColor) {
      that.coloreBarraTitolo = specificHeaderBackColor;
    }
    let specificHeaderTextColor = jsonHelper.getProperty(
      that.projects,
      that.path + ".cardHeaderTextColor"
    );
    if (specificHeaderTextColor) {
      that.colorecoloreTesto = specificHeaderTextColor;
    }
    let specificCardLabel = jsonHelper.getProperty(that.projects, that.path + ".cardHeaderLabel");
    if (specificCardLabel) {
      that.cardLabel = specificCardLabel;
    }
    //});
  },
  methods: {}
};
</script>

<style lang="scss"></style>
